"use client";
import { Checkbox} from 'pretty-checkbox-react';
import styles from './styles.module.scss';

const ToggleBar = props => {
    const {setFilters} = props || {};

    const handleCheck = () => {
        
    }
    return(
        <nav className={styles.toggleBar}>
            <Checkbox data-name="NEWS">
                News
            </Checkbox>
            <Checkbox data-name="WEBINAR">
                Webinars
            </Checkbox>
            <Checkbox data-name="SUCCESS_STORIES">
                Success Stories
            </Checkbox>
            <Checkbox data-name="blogs">
                Blogs
            </Checkbox>
        </nav>
    );
}

export default ToggleBar;